// src/hooks/useConnections.js

import { useState, useEffect } from 'react';
import { db } from '../config/firebase';
import { doc, onSnapshot, collection, query, where, getDocs } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext'; // Use the context for reliability

export const useConnections = () => {
  const { currentUser } = useAuth(); // Get user from context
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      return;
    }

    const userDocRef = doc(db, 'users', currentUser.uid);
    // This real-time listener will now correctly fire whenever your document changes
    const unsubscribe = onSnapshot(userDocRef, async (userDoc) => {
      setLoading(true);
      const userData = userDoc.data();
      const connectionsList = userData?.connections || [];
      const blockedUsersList = userData?.blockedUsers || [];

      if (connectionsList.length > 0) {
        try {
          const connectionsQuery = query(collection(db, 'users'), where('uid', 'in', connectionsList));
          const querySnapshot = await getDocs(connectionsQuery);
          let connectionsData = [];
          querySnapshot.forEach((connectionDoc) => {
            connectionsData.push(connectionDoc.data());
          });
          
          // It still correctly filters out blocked users
          connectionsData = connectionsData.filter(user => !blockedUsersList.includes(user.uid));
          setConnections(connectionsData);
        } catch (err) {
            console.error("Error fetching connections data:", err);
            setConnections([]);
        }
      } else {
        setConnections([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser]); // This dependency is key

  return { connections, loading };
};